import { FACILITY_IDS, FACILITY_STORAGE_KEY, resolveFacilityId } from './facilities';

/** Shop print servers. Dev uses the setupProxy paths so the browser can skip the self-signed cert. */
const PRINT_SERVERS = {
  [FACILITY_IDS.CENTRAL]: {
    host: '192.168.1.87',
    devPath: '/print-api',
  },
  [FACILITY_IDS.STRAWBERRY_PATCH]: {
    host: '192.168.1.119',
    devPath: '/print-api/strawberryPatch',
  },
};

export const getPrintServerUrl = (facilityId) => {
  const facility = resolveFacilityId(facilityId || getActivePrintFacilityId());
  const server = PRINT_SERVERS[facility] || PRINT_SERVERS[FACILITY_IDS.CENTRAL];
  if (process.env.NODE_ENV === 'development') {
    return `${server.devPath}/print-label-base64`;
  }
  return `https://${server.host}:9100/print-label-base64`;
};

/** Facility currently selected in the navbar. Read at print time so a toggle applies immediately. */
export function getActivePrintFacilityId() {
  try {
    return resolveFacilityId(localStorage.getItem(FACILITY_STORAGE_KEY));
  } catch (_) {
    return resolveFacilityId(null);
  }
}

/** Send a base64 PDF label to the local print server for the active facility. */
export async function printLabelBase64(pdfData, { type = 'line', tray = 1, facilityId } = {}) {
  const facility = resolveFacilityId(facilityId || getActivePrintFacilityId());
  const response = await fetch(getPrintServerUrl(facility), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      type,
      pdfData,
      tray,
      method: 'direct-lp',
      facilityId: facility,
    }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Print server error: ${response.status} - ${errorText}`);
  }

  const result = await response.json();
  if (!result.success) {
    throw new Error(result.error || 'Print server error');
  }

  return result;
}
